import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import HotBoxesJunePrint from "./HotBoxesJunePrint";
import CallToActionJune from "./CallToActionJune";
import MiniTablePro from "views/PmaAdmin/MiniTablePro";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";

const HotBoxesJuneEditor = React.lazy(() => import("./HotBoxesJuneEditor"));
const HOT_BOXES_AND_TABLE_DOUBLE_NUMBERS_BG =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/060126_Dashboard-3-PhoneNum_BackGround_3.jpg";
const HOT_BOXES_AND_TABLE_BG =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/060126_Dashboard_BackGround_2.jpg";

class HotBoxesAndTable extends Component {
  componentDidMount() {
    require("./print.scss");
  }
  render() {
    const {
      printVersion,
      currentArea,
      quarterlyAreaTable,
      hoData,
      agentData,
      miniTableDetailsDTO,
      useExtendedTable,
      fromEditor,
      showAllEditButtons,
      keyMarketAvgsList,
    } = this.props;
    const { listgenUserID } = agentData;
    console.log("*****hotBoxesAndTable", this.props);
    let useDoubleNumbers = false;
    if (listgenUserID === "102512") {
      useDoubleNumbers = true;
    }

    const hotBoxesBackground = useDoubleNumbers
      ? HOT_BOXES_AND_TABLE_DOUBLE_NUMBERS_BG
      : HOT_BOXES_AND_TABLE_BG;
    return (
      <div className={`${printVersion ? "print" : "editor"}-qv4-second-left`}>
        <div
          className={`hot-boxes-and-table-page ${fromEditor ? "from-editor" : ""}`}
          style={{
            backgroundImage: `url(${hotBoxesBackground})`,
          }}
        >
          {fromEditor ? (
            <Suspense fallback={null}>
              <HotBoxesJuneEditor
                keyMarketAvgsList={keyMarketAvgsList}
                currentArea={currentArea}
                agentData={agentData}
                showAllEditButtons={showAllEditButtons}
              />
            </Suspense>
          ) : (
            <HotBoxesJunePrint
              keyMarketAvgsList={keyMarketAvgsList}
              currentArea={currentArea}
            />
          )}
          <MiniTablePro
            currentArea={currentArea}
            quarterlyAreaTable={quarterlyAreaTable}
            hoData={hoData}
            agentData={agentData}
            printVersion={!fromEditor} //printVersion && fromEditor
            fromEditor={fromEditor}
            miniTableDetailsDTO={miniTableDetailsDTO}
            useExtendedTable={useExtendedTable}
            tableMonthStyles="november-table-container"
            showAllEditButtons={showAllEditButtons}
          />
          <CallToActionJune
            agentData={agentData}
            useDoubleNumbers={useDoubleNumbers}
            currentArea={currentArea}
          />
          <QVFourEmailAndWebsiteFooter
            agentData={agentData}
            currentArea={currentArea}
            printVersion={printVersion}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  miniTableDetailsDTO: state.pma.miniTableDetailsDTO,
  keyMarketAvgsList: state.pma.keyMarketAvgsList,
});

const mergeProps = (stateProps, _dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  miniTableDetailsDTO:
    ownProps.miniTableDetailsDTO ?? stateProps.miniTableDetailsDTO,
  keyMarketAvgsList: ownProps.keyMarketAvgsList ?? stateProps.keyMarketAvgsList,
});

export default connect(mapStateToProps, null, mergeProps)(HotBoxesAndTable);
